'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'imageWrap', 'image', 'content'];
var baseStyle = function baseStyle(props) {
  var isOverflowing = props.isOverflowing,
    imageWidth = props.imageWidth,
    spacingBottom = props.spacingBottom,
    spacingLeft = props.spacingLeft;
  return {
    container: {
      display: 'flex'
    },
    imageWrap: _objectSpread(_objectSpread(_objectSpread({}, !isOverflowing && {
      mr: 4
    }), isOverflowing && {
      position: 'relative',
      ml: 2
    }), {}, {
      flexShrink: 0,
      flexGrow: 0,
      flexBasis: imageWidth,
      display: {
        base: 'none',
        md: 'block'
      }
    }),
    image: _objectSpread(_objectSpread({}, isOverflowing && {
      position: 'absolute',
      left: utils.mapResponsive(spacingLeft, function (v) {
        return -v;
      }),
      bottom: utils.mapResponsive(spacingBottom, function (v) {
        return -v;
      })
    }), {}, {
      width: '100%'
    }),
    content: {}
  };
};
var defaultProps = {};
var CardColumnWrapper = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = CardColumnWrapper;